import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AuthorizationService } from '@nimmsta/ng-commons-lib/auth';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';
import {
  TabsConfiguration,
  ReusableTabsComponent,
} from '@nimmsta/ng-commons-lib/reusable-tabs';
import { UserRole } from '@nimmsta/ng-commons-lib/models';
import { UserComponent } from './user.component';
import { WorkerComponent } from '../worker/worker.component';

enum Tabs {
  MANAGER = 'manager',
  SECONDARY_USER = 'secondary-user',
  WORKER = 'worker',
}

@Component({
  selector: 'app-user-overview',
  templateUrl: 'user-overview.component.html',
  imports: [
    ReusableTabsComponent,
    UserComponent,
    WorkerComponent,
    HeaderBarComponent,
  ],
})
export class UserOverviewComponent implements OnInit {
  @ViewChild('managerTabContent', { static: true })
  managerTabContent!: TemplateRef<unknown>;
  @ViewChild('workerTabContent', { static: true })
  workerTabContent!: TemplateRef<unknown>;

  private authorizationService = inject(AuthorizationService);

  protected tabsConfig: TabsConfiguration = {
    tabs: [],
    defaultTab: Tabs.MANAGER,
    storageKey: 'userOverview',
    enableRouting: true,
  };

  protected showAdminActions = false;

  ngOnInit(): void {
    const visibleTabs = [
      this.authorizationService.matches({
        anyRoles: [UserRole.ADMIN, UserRole.MANAGER],
      })
        ? {
            id: Tabs.MANAGER,
            labelKey: 'MANAGER',
            template: this.managerTabContent,
          }
        : undefined,
      this.authorizationService.matches({
        anyPermissions: ['worker.read', 'worker.write'],
      })
        ? {
            id: Tabs.WORKER,
            labelKey: 'worker.title',
            template: this.workerTabContent,
          }
        : undefined,
    ].filter((tab): tab is NonNullable<typeof tab> => !!tab);

    this.tabsConfig = {
      ...this.tabsConfig,
      tabs: visibleTabs,
      defaultTab: visibleTabs[0]?.id ?? Tabs.MANAGER,
    };
  }
}
